import React from 'react'
import { css } from '@emotion/core'
import { VisuallyHidden } from '@reach/visually-hidden'
import { useTranslation } from 'react-i18next'
import getIsTWAMode from './appMode_helper'
import { getAppBackground } from './appTheme'
import { Z_INDICES } from '../constants/zIndices'

const holdCss = (background) => css`
  position: fixed;
  inset: 0;
  z-index: ${Z_INDICES.LOADING_HOLD};
  background-color: ${background};
`

/**
 * A full-screen pane of the app's own background colour, used in place of a spinner while the app
 * boots inside the Together Android app.
 *
 * There is deliberately nothing to see, but a screen reader still needs to be told the app is
 * working — otherwise replacing the spinner trades a visible pause for a silent one.
 */
export function LoadingHold() {
  const [t] = useTranslation(undefined, { useSuspense: false })

  return (
    <div css={holdCss(getAppBackground())} data-testid="activity-loading-hold">
      <VisuallyHidden>
        <output aria-live="polite">{t('common.loading', 'Loading')}</output>
      </VisuallyHidden>
    </div>
  )
}

/**
 * @param {React.ReactElement} indicator What to show outside the Together Android app.
 * @returns {React.ReactElement}
 */
export default function getLoadingFallback(indicator) {
  if (!getIsTWAMode()) {
    return indicator
  }

  return <LoadingHold />
}
